<ng-container *ngIf="dataReady">
    <router-outlet></router-outlet>
</ng-container>